import ANTDSelect from '../../../../shared/antd/ANTDSelect'
import { entries, include } from '../../../../utils/javascript'
import refrigerantType from '../../container/refrigerantType.container'
import { allowedRefTypes } from '../../jobs.description'

const RefrigerantType = ({ ...props }) => {
  const { refrigerantList, loader } = refrigerantType()

  return (
    <ANTDSelect
      {...{ ...props }}
      loading={loader}
      showSearch
      virtual={false}
      popupClassName="select-group"
      options={
        entries(refrigerantList)
          ?.filter(([key]) => include(allowedRefTypes, key))
          ?.map(([key, val], index) => ({
            label: (
              <span
                className={`refrigerant-title ${key?.toLowerCase()}-background`}
              >
                <p>{key}</p>
              </span>
            ),
            title: key,
            options: val?.map(ref => ({
              label: ref?.refrigerantType,
              value: ref?.refrigerantType,
              key: `${ref?.id}-${index}`,
              className: `${key?.toLowerCase()}-background`,
            })),
          })) || []
      }
    />
  )
}

export default RefrigerantType
